import { ListItem } from '@app/shared/ui/molecules/Admin/Users';
import type { User } from '@app/shared/types/admin/pages/users';

interface ListSectionProps {
  users: User[];
}

export function ListSection({ users }: ListSectionProps) {
  return (
    <ul className="flex flex-col gap-2 px-3">
      {users.map((user) => (
        <ListItem key={user.id} user={user} />
      ))}
    </ul>
  );
}
